const m = window.require("@ember/object/computed");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;